import React from 'react';
import styles from './styles/NotAvailableStyles';
import { localize } from 'react-localize-redux';

const NotAvailable = ({translate}) => {
    return (
        <div style={styles.content} >
            <span>{translate('GLOBAL.notAvailable')} </span>
        </div>
    );
};

export default localize(NotAvailable, 'locale');


// WEBPACK FOOTER //
// ./src/components/notAvailable/NotAvailable.js